import { render, staticRenderFns } from "./HotelBoard.vue?vue&type=template&id=34a320b5&"
import script from "./HotelBoard.vue?vue&type=script&lang=js&"
export * from "./HotelBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports